import Typography from 'components/generics/texts/Typography';
import classes from './index.module.scss';
import FormComponent from './components/FormComponent';

const MaintenanceForm = () => {
  return (
    <div className={classes.mainContainer}>
      <Typography className={classes.title}>New Repair Request</Typography>
      <Typography className={classes.subTitle}>
        Sent over the info - our team will be on it
      </Typography>
      <FormComponent />
    </div>
  );
};

export default MaintenanceForm;
